/**
 * Percent formatting for the backtest table.
 *
 * Returns here span four orders of magnitude, and two fixed decimals on a six-figure percentage is
 * false precision that also forces the cell to wrap. Precision therefore scales inversely with
 * magnitude, and thousands separators keep large values readable at a glance.
 */
export const formatBacktestPercent = (value: number): string => {
    const magnitude = Math.abs(value);
    const maximumFractionDigits = magnitude >= 1000 ? 0 : magnitude >= 100 ? 1 : 2;

    return `${value.toLocaleString(undefined, { maximumFractionDigits })}%`;
};
